import {tns} from "tiny-slider";

const initMultipleSliders = function(className, initFunction) {
    const containers = Array.prototype.slice.call(document.getElementsByClassName(className));
    containers.forEach(container => initFunction(container));
}

// const initLeaderboardMobileSlider = function() {
//     initMultipleSliders("mobile-slider", (container) => {
//         tns({
//             container: container,
//             items: 1, // mobile
//             gutter: 20,
//             loop: true,
//             slideBy: 1,
//             autoplay: false,
//             mouseDrag: true,
//             speed: 1600,
//             controls: true,
//             nav: true,
//             arrowKeys: true,
//             preventScrollOnTouch: "auto",
//             autoplayButtonOutput: false,
//             controlsText: ["", ""]
//         })
//     })
// };

const initLeaderboardMobileSlider = function() {
    tns({
        container: ".mobile-slider",
        items: 1, // mobile
        gutter: 20,
        loop: true,
        slideBy: 1,
        autoplay: false,
        mouseDrag: true,
        speed: 1600,
        controls: true,
        nav: true,
        arrowKeys: true,
        preventScrollOnTouch: "auto",
        autoplayButtonOutput: false,
        controlsText: ["", ""]
    })

};


export { initLeaderboardMobileSlider };
